import React from 'react';

import scss from './Image.module.scss';

function Image({ item, onError }) {
  const handleError = () => {
    onError?.(item);
  };

  return (
    <img
      src={item.preview}
      alt={item.name}
      className={scss.image}
      role='presentation'
      onError={handleError}
      loading='lazy'
      decoding='async'
    />
  );
}

export default Image;
